import React from 'react';
import { useNavigate } from 'react-router-dom';
import useLargeBreakpoint from '../../hooks/useLargeBreakpoint';
import PackageCard from '../options/packageCard/PackageCard';

const PackageCards = ({
  options,
  onChange,
  isUpdating,
  selectingOption,
  analyticsKey,
  stacked,
}) => {
  const navigate = useNavigate();

  if (!options || options.length === 0) {
    return null;
  }

  const isAtLeastLarge = useLargeBreakpoint();
  const onDetails = (option) => {
    navigate(`package/${option.code}`);
  };

  return (
    <>
      {isAtLeastLarge ? (
        <>
          {options.length === 1 ? (
            <div className="packages-options__grid--single">
              <PackageCard
                key={options[0].code}
                option={options[0]}
                onChange={() => {
                  onChange(options[0]);
                }}
                onDetails={onDetails}
                analyticsKey={analyticsKey}
                isUpdating={isUpdating}
                selectingOption={selectingOption}
                stacked={false}
              />
            </div>
          ) : (
            <div className="packages-options__grid--multiple">
              {options.map((option, index) => {
                return (
                  <PackageCard
                    key={option.code}
                    option={option}
                    onChange={() => {
                      onChange(option);
                    }}
                    onDetails={onDetails}
                    analyticsKey={analyticsKey}
                    isUpdating={isUpdating}
                    selectingOption={selectingOption}
                    stacked={true}
                  />
                );
              })}
            </div>
          )}
        </>
      ) : (
        <div className="packages-options__grid--multiple">
          {options.map((option) => {
            return (
              <PackageCard
                key={option.code}
                option={option}
                onChange={() => {
                  onChange(option);
                }}
                onDetails={onDetails}
                analyticsKey={analyticsKey}
                isUpdating={isUpdating}
                selectingOption={selectingOption}
                stacked={stacked}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default PackageCards;
